
const arraygex = [];
arraygex["stopListening"] = /arrête d'écouter/g;
arraygex["switchPlaylistMario"] = /[passe sur|mets] la playlist de Mario/g;
arraygex["switchPlaylistSimon"] = /[passe sur|mets] la playlist de [Simon|ciment]/g;
arraygex["playmusic"] = /joue la musique/g;
arraygex["stopmusic"] = /arrête la musique/g;


export default arraygex;